import { Component, Input } from '@angular/core';
import { constants } from 'constants/constants';
import _get from 'lodash-es/get';
import { ComputedFrom } from '@certemy/common';
import { STEP_COLOR_STATUSES, STEP_TYPES } from 'constants/status.constants';
import { REJECT_HINT_TYPES } from 'components/hint/hint.constants';
import { isRollingAuditStep } from 'features/professional-step/education/ce-types/general/general-ce-type.component.helpers';
import { LOG_STEP_RESPONSIBLE_TO_COMPLETE } from 'constants/log-step.constants';

@Component({
  selector: 'cm-step-details-header-icon',
  templateUrl: './step-details-header-icon.component.html',
  styleUrls: ['./step-details-header-icon.component.scss'],
})
export class StepDetailsHeaderIconComponent {
  readonly REJECT_HINT_TYPES = REJECT_HINT_TYPES;
  readonly LOG_STEP_RESPONSIBLE_TO_COMPLETE = LOG_STEP_RESPONSIBLE_TO_COMPLETE;
  @Input() data;

  @ComputedFrom('data')
  get isEducationStep(): boolean {
    return this.data.step_type_id === STEP_TYPES.EDUCATION;
  }

  @ComputedFrom('data')
  get isAuditStep(): boolean {
    return isRollingAuditStep(this.data);
  }

  @ComputedFrom('data', 'isEducationStep')
  get auditStatusId(): number {
    return this.isEducationStep ? _get(this.data, 'content.auditStatusId', null) : null;
  }

  @ComputedFrom('data', 'auditStatusId', 'isAuditStep')
  get stepStatusColor(): number {
    return this.isAuditStep && !this.auditStatusId ? STEP_COLOR_STATUSES.PENDING : this.data.status_color;
  }

  private constants = constants;
  step_class: any = {};
  constructor() {
    this.step_class[STEP_TYPES.DYNAMIC] = 'df';
    this.step_class[STEP_TYPES.FEES] = 'fee';
    this.step_class[STEP_TYPES.OTHER_CERTIFICATE] = 'other';
    this.step_class[STEP_TYPES.EVIDENCE_FILE] = 'ef';
    this.step_class[STEP_TYPES.EDUCATION] = 'edu';
    this.step_class[STEP_TYPES.TEST] = 'test';
    this.step_class[STEP_TYPES.REGISTRATION_FORM] = 'reg-form';
    this.step_class[STEP_TYPES.LOG] = 'log';
    this.step_class[STEP_TYPES.LOG_NEW] = 'log';
  }
}
